const stepLabels = [
  { step_title: "Project Description", step_description: "Review the details of project" },
  {
    step_title: "Model Validation Scope", step_description: "Define the validation scope for the project"
  },
  {
    step_title: "Model Specifications",
    step_description: "Define the vendor documentation, model cards, design and training details.",
    dropdown_label:
      "Choose another model specifications template",
  },
  { step_title: "System Specifications", step_description: "Describe how the model fits into the system." },
  {
    step_title: "Policy and Compliance",
    step_description: "Define internal model governance policies, SR‐11‐7 guidance, UK PRA model‐risk principles, MAS/FEAT guidelines and regional laws for the project",
    dropdown_label:
      "Choose another policy and compliance template",
  },
  { step_title: "Overview", step_description: "Review the details of the project so far" },
  { step_title: "Model Validation Document", step_description: "Review the model validation plan generated for you based on your inputs" },
];

export default stepLabels;
